import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseUpdateReviewRequest
*  Правка своего отзыва.
*/
export class ShowcaseUpdateReviewRequest extends ActiveModel {

  /**
  * rating
  * Оценка 1–5.  */
  @ActiveField()
  rating?: number


/**
  * pros
  * Достоинства.
  */
  @ActiveField()
  pros?: null | string


/**
  * cons
  * Недостатки.
  */
  @ActiveField()
  cons?: null | string


/**
  * text
  * Комментарий.
  */
  @ActiveField()
  text?: null | string


/**
  * resourceIds
  * Полный новый набор фото, в порядке показа.  */
  @ActiveField({
    setter(model: ShowcaseUpdateReviewRequest, prop: string, value: Array<string> | undefined, receiver?: ShowcaseUpdateReviewRequest ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  resourceIds?: Array<string>
}
